import cialfoLogo from "src/assets/explore-logo.svg";

/**
 * Brand registry — the single place to define anything that differs per
 * embedding app/brand: logo, feature flags, and copy overrides.
 *
 * A brand is identified by `?brand=<id>` on the URL (see Utility.getBrandId).
 * Adding a brand = one object literal here.
 *
 * Colors are NOT defined here — they live as CSS variables in
 * src/css/brand.css, switched at runtime via the `data-brand` attribute on
 * <html> (see src/brands/apply-theme.js). A brand that overrides colors must
 * add a matching `[data-brand="<id>"]` block there.
 */

export const DEFAULT_BRAND_ID = "cialfo";

// Placeholder logo until real BridgeU art is added to src/assets.
const bridgeuLogo = cialfoLogo;

export const BRANDS = {
  cialfo: {
    id: "cialfo",
    name: "Cialfo Explore",
    logo: cialfoLogo,
    features: { showTours: true, visitsRedesign: false },
    copy: {},
  },
  bridgeu: {
    id: "bridgeu",
    name: "BridgeU",
    logo: bridgeuLogo,
    // visitsRedesign swaps the All-visits tab for the BridgeU visits layout
    // (see src/screens/events/bridgeu). Every other brand keeps the original.
    features: { showTours: false, visitsRedesign: true },
    copy: {},
  },
};

export function getBrandConfig(brandId) {
  return BRANDS[brandId] || BRANDS[DEFAULT_BRAND_ID];
}
